var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIntercom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.067 32.343a1.233 1.233 0 01-2.467 0V21.25a1.233 1.233 0 012.467 0v11.093zm-.43 7.72c-.191.162-4.76 3.996-13.137 3.996s-12.945-3.834-13.136-3.997a1.234 1.234 0 011.603-1.875c.072.06 4.152 3.406 11.533 3.406 7.474 0 11.49-3.37 11.53-3.404a1.233 1.233 0 111.606 1.873zM16.932 21.25a1.233 1.233 0 012.467 0v11.093a1.233 1.233 0 01-2.467 0V21.25zm6.167-2.467a1.234 1.234 0 012.467 0V35.26a1.233 1.233 0 01-2.467 0V18.783zm6.167-.624a1.233 1.233 0 112.466 0v17.883a1.233 1.233 0 01-2.466 0V18.16zm6.166.624a1.234 1.234 0 012.467 0V35.26a1.234 1.234 0 01-2.467 0V18.783zM44.375 12h-27.75A4.625 4.625 0 0012 16.625v27.75A4.625 4.625 0 0016.625 49h27.75A4.625 4.625 0 0049 44.375v-27.75A4.625 4.625 0 0044.375 12z",
    fill: "#1F8DED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntercom);
export default __webpack_public_path__ + "static/media/intercom.a3d333d2d59b65fbb620456dc9d6038b.svg";
export { ForwardRef as ReactComponent };